import { useTranslations } from "next-intl";
import classNames from "classnames";
import useCustomizableCloset, { useAnticipatedAddOnCount } from "@hooks/use-customizable-closet";
import Button from "@components/core/Button";

function ClosetRTCFillingProgress({ setStep }) {
  const t = useTranslations("common");

  const currentCloset = useCustomizableCloset();
  const anticipatedAddOnCount = useAnticipatedAddOnCount();

  const { plan } = currentCloset;
  const closetItemsCount = currentCloset.closet_items.length;
  const closetPlanPieces = plan.clothes + plan.accessories;
  const closetItemsAnticipatedCount = closetPlanPieces + anticipatedAddOnCount;

  function showBonusItemExplanation() {
    setStep("bonusItemExplanation");
  }

  function displayClosetItemsFillBlocks() {
    return Array.from({ length: closetItemsAnticipatedCount }, (_, index) => (
      <div
        key={index}
        className={classNames("closet-item-block", index < closetItemsCount ? "filled" : "empty")}
      />
    ));
  }

  function displayInstructionText() {
    if (closetItemsCount === 0) {
      return t("drawer.modal_rtc.change.instructions.no_item");
    }

    if (currentCloset.ready_to_pack_status.reason === "too_few_selected_items") {
      return t("drawer.modal_rtc.change.instructions.not_enough_item");
    }

    return t("drawer.modal_rtc.change.instructions.enough_item");
  }

  return (
    <div className="px-4 py-3 bg-white">
      <h5 className="mb-0 text-center">
        {t("drawer.modal_rtc.change.add_items_bonus", {
          closetItemsCount,
          closetItemsAnticipatedCount,
          count: anticipatedAddOnCount,
        })}
      </h5>

      <div className="closet-item-blocks-container">{displayClosetItemsFillBlocks()}</div>

      <p className="text-center text-gray mb-2">{displayInstructionText()}</p>

      <div className="w-100 d-flex justify-content-center">
        <Button
          variant="link-primary"
          className="no-underline"
          onClick={showBonusItemExplanation}
        >
          {t("drawer.modal_rtc.change.about_add_on_btn")}
        </Button>
      </div>
    </div>
  );
}

export default ClosetRTCFillingProgress;
